import { Flex, Th } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { IoChevronDown, IoChevronUp } from 'react-icons/io5'

const SortableTh = ({ children, name, sorting, setSorting }) => {
  const handleSorting = () => {
    setSorting({
      column: name,
      direction: sorting.direction === 'asc' ? 'desc' : 'asc',
    })
  }
  return (
    <Th onClick={handleSorting}>
      <Flex alignItems="center" cursor={'pointer'} gap={2}>
        {children}
        {sorting.column === name && sorting.direction === 'asc' && <IoChevronUp />}
        {sorting.column === name && sorting.direction === 'desc' && <IoChevronDown />}
      </Flex>
    </Th>
  )
}

SortableTh.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  sorting: PropTypes.shape({
    column: PropTypes.string,
    direction: PropTypes.string,
  }),
  setSorting: PropTypes.func.isRequired,
}

export default SortableTh
